<template>
  <div class="business">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">单位名称：</span>
        </div>
        <el-input v-model="formData.enterpriseName" :maxlength="24" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">纳税人识别号：</span>
        </div>
        <el-input v-model="formData.taxpayerRegisterNumber" :maxlength="24" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">经办人姓名：</span>
        </div>
        <el-input v-model="formData.personName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">经办人手机：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">经办人身份证：</span>
        </div>
        <el-input v-model="formData.identityNumber" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">申请房型：</span>
        </div>
        <el-select v-model="formData.rentType" placeholder="请选择" size="mini" style="width: 280px">
          <el-option v-for="item in rentTypeList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预入住日期：</span>
        </div>
        <el-date-picker v-model="formData.stayStartTime" type="date" size="small" style="width: 280px" :editable=false value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">预租期限：</span>
        </div>
        <el-select v-model="formData.leaseTimeLimit" placeholder="请选择" size="mini" style="width: 280px">
          <el-option v-for="item in leaseTimeLimitList" :key="item.key" :label="item.label" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.remarks" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {errorHandler} from '../../../utils/errorHandler'
import {api} from '../../api/LeaseManage'
import {nError, nSuccess} from '../../../utils/notice'
import InputTree from '../../../components/common/inputs/input-tree'
import {treeApi} from '../../api/TreeApi'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import {pattern} from '../../../utils/regular'
import {bus} from "../../../utils/bus";

export default {
  components: {
    ButtonConfirmNext,
    InputTree,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'business-add',
  data () {
    return {
      breadcrumb: [{
        value: '资源中心',
        name: 'yq-information'
      }, {
        value: '单位承租'
      }],
      mainTitle: '添加单位',
      subheading: '',
      roomType: '0',
      enterpriseLogoBase64: '',
      rentTypeList: [
        {key: 0, label: '整租'},
        {key: 1, label: '床位'}
      ],
      leaseTimeLimitList: [
        {key: '一个月', label: '一个月'},
        {key: '三个月', label: '三个月'},
        {key: '半年', label: '半年'},
        {key: '一年', label: '一年'},
        {key: '一年以上', label: '一年以上'},
      ],
      formData: {
        enterpriseName: '',
        personName: '',
        phone: '',
        identityNumber: '',
        taxpayerRegisterNumber: '',
        stayStartTime: '',
        leaseTimeLimit: '',
        roomType: '',
        rentType: 0,
        leaseNum: '',
        remarks: ''
      },

      uploadHeaders: {
        token: bus.global.token,
        'yq-app-code': bus.global.yqCode,
      },
      uploadAction: api.uploadImg,
    }
  },
  created() {},
  methods: {
    // 上传成功
    uploadContractSuccess (res) {
      this.formData.businessLicense = res.data.fileUrl
      this.$refs.uploadContract.clearFiles()
    },
    // 重新上传成功
    uploadContractReviewSuccess (res) {
      this.formData.businessLicense = res.data.fileUrl
      this.$refs.uploadContractReview.clearFiles()
    },
    // 上传失败
    uploadContractError (err) {
      nError('上传失败')
    },
    previewFile (url) {
      if (url.indexOf('doc') === -1) {
        window.open(url, '_blank')
      } else {
        window.open('http://view.officeapps.live.com/op/view.aspx?src=' + url, '_blank')
      }
    },
    toBusinessManagement () {
      this.$router.push({
        name: 'business-management'
      })
    },
    upData2: function () {
      let that = this
      const oFReader = new FileReader()
      const file = document.getElementById('uploadBackgroundImg').files[0]
      if (file.size > 1024 * 1024) {
        nError('上传图片不能大于1M')
        return false
      }
      oFReader.readAsDataURL(file)
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result
        that.enterpriseLogoBase64 = src
        that.uploadPicture()
      }
    },
    upImg2: function () {
      $('#uploadBackgroundImg')
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on('change', function () {
          // const objUrl = getObjectURL(this.files[0])
          // if (objUrl) {
          //   $('#pic2').attr('src', objUrl)
          // }
        })
    },
    // 上传图片
    uploadPicture () {
      this.$axios.post(api.uploadImg, {
        picData: this.enterpriseLogoBase64
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData.enterpriseLogo = res.data.data
          } else {
            // 提示信息，需引入Message
            nError('图片上传失败')
          }
        })
        .catch(errorHandler('图片上传失败'))
    },
    confirm () {
      // let checkEnterpriseName = pattern.characterInput_24.test(this.formData.enterpriseName)
      let checkPhone = pattern.telephoneOrPhone.test(this.formData.phone)

      if (!this.formData.enterpriseName) {
        nError('请输入单位名称')
        return false
      }
      /*if (!this.formData.taxpayerRegisterNumber) {
        nError('请输入纳税人识别号')
        return false
      }*/
      if (!this.formData.personName) {
        nError('请输入经办人姓名')
        return false
      }
      if (!this.formData.phone) {
        nError('请输入经办人手机')
        return false
      }
      if (this.formData.phone && !checkPhone) {
        nError('手机格式不正确')
        return false
      }
      if (!this.formData.identityNumber) {
        nError('请输入经办人身份证号')
        return false
      }
      this.$axios.post(api.addEnterpriseLease, this.formData)
        .then(res => {
          nSuccess('添加成功')
          this.toBusinessManagement()
        })
        .catch(errorHandler('添加失败'))
    },

    cancel () {
      this.toBusinessManagement()
    },
  },

  watch: {}
}
</script>

<style lang="less">
  .business {
    .form-line .el-checkbox__label {
      width: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/BusinessManagement/BusinessAdd.vue